import { FocusManager } from '../services/focus-manager';

export function swFocus(sharedModule) {
  /**
   * Directive that sets fields for focusManager
   */
  sharedModule.directive('swFocus', (focusManager: FocusManager) => ({
    restrict: 'A',
    require: 'ngModel',

    link: function postLink(scope, element, attrs, $ctrl) {
      let getter = () => $ctrl.$viewValue;

      let setter = (value) => {
        $ctrl.$setViewValue(value);
        $ctrl.$render();
      };

      // workaround for setting at least *one* input focused
      focusManager.set(getter, setter);

      element.on('focus', () => {
        focusManager.set(getter, setter);
      });

      scope.$on('$destroy', () => {
        focusManager.reset();
        getter = null;
        setter = null;
      });
    },
  }));
}
